import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "subtitle-1 pa-0 ma-0" },
        [
          _c("span", [_vm._v(_vm._s(_vm.value.titulo))]),
          _c(VSwitch, {
            staticClass: "ml-4",
            attrs: { color: "secondary", dense: "" },
            model: {
              value: _vm.value.habilitado,
              callback: function ($$v) {
                _vm.$set(_vm.value, "habilitado", $$v)
              },
              expression: "value.habilitado",
            },
          }),
        ],
        1
      ),
      _c(
        VCardText,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.habilitado,
              expression: "value.habilitado",
            },
          ],
          staticClass: "pa-0 ma-0",
        },
        [
          _c(
            VCard,
            { attrs: { flat: "" } },
            [
              _c(
                VCardTitle,
                { staticClass: "subtitle-1 pa-0 ma-0" },
                [
                  _c(VIcon, { staticClass: "mr-2" }, [
                    _vm._v(" access_time "),
                  ]),
                  _c(VTextField, {
                    staticStyle: { "max-width": "48px" },
                    attrs: { type: "number", min: 0 },
                    on: {
                      blur: function ($event) {
                        return _vm.validate("anos", _vm.value.anos)
                      },
                    },
                    model: {
                      value: _vm.value.anos,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "anos", $$v)
                      },
                      expression: "value.anos",
                    },
                  }),
                  _c("span", { staticClass: "ml-1 mr-4" }, [
                    _vm._v("ano(s) e"),
                  ]),
                  _c(VTextField, {
                    staticStyle: { "max-width": "48px" },
                    attrs: { type: "number", min: 0, max: 11 },
                    on: {
                      blur: function ($event) {
                        return _vm.validate("meses", _vm.value.meses)
                      },
                    },
                    model: {
                      value: _vm.value.meses,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "meses", $$v)
                      },
                      expression: "value.meses",
                    },
                  }),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("mês(es)")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("children"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }